import React, { useState } from 'react';
import Quarter from './Quarter';

const QuarterTest = () => {
    const [quarterPositions, setQuarterPositions] = useState([
        { id: 0, quarter: "Q1", value: "4", color: "#DC2C36", position: 0 },
        { id: 1, quarter: "Q2", value: "2", color: "#1D8DFA", position: 1 },
        { id: 2, quarter: "Q3", value: "0", color: "#10B981", position: 2 },
        { id: 3, quarter: "Q4", value: "0", color: "#F59E0B", position: 3 }
    ]);

    const [draggedIndex, setDraggedIndex] = useState(null);
    const [dragOverIndex, setDragOverIndex] = useState(null);

    const handleDragStart = (e, index) => {
        setDraggedIndex(index);
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/html', e.target.outerHTML);
    };

    const handleDragEnd = () => {
        setDraggedIndex(null);
        setDragOverIndex(null);
    };

    const handleDragOver = (e, index) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        setDragOverIndex(index);
    };

    const handleDrop = (e, dropIndex) => {
        e.preventDefault();

        if (draggedIndex === null || draggedIndex === dropIndex) return;

        const newPositions = [...quarterPositions];
        const draggedItem = newPositions[draggedIndex];
        const dropItem = newPositions[dropIndex];

        // Swap positions
        newPositions[draggedIndex] = { ...dropItem, position: draggedIndex };
        newPositions[dropIndex] = { ...draggedItem, position: dropIndex };

        setQuarterPositions(newPositions);
        setDraggedIndex(null);
        setDragOverIndex(null);
    };

    const resetPositions = () => {
        setQuarterPositions([
            { id: 0, quarter: "Q1", value: "4", color: "#DC2C36", position: 0 },
            { id: 1, quarter: "Q2", value: "2", color: "#1D8DFA", position: 1 },
            { id: 2, quarter: "Q3", value: "0", color: "#10B981", position: 2 },
            { id: 3, quarter: "Q4", value: "0", color: "#F59E0B", position: 3 }
        ]);
    };

    const updateScore = (index, newValue) => {
        const newPositions = [...quarterPositions];
        newPositions[index].value = newValue;
        setQuarterPositions(newPositions);
    };

    const changeLayout = (layoutType) => {
        let newPositions = [...quarterPositions];

        switch (layoutType) {
            case 'chronological':
                newPositions = [
                    { id: 0, quarter: "Q1", value: "4", color: "#DC2C36", position: 0 },
                    { id: 1, quarter: "Q2", value: "2", color: "#1D8DFA", position: 1 },
                    { id: 2, quarter: "Q3", value: "0", color: "#10B981", position: 2 },
                    { id: 3, quarter: "Q4", value: "0", color: "#F59E0B", position: 3 }
                ];
                break;
            case 'score-priority':
                newPositions = [
                    { id: 0, quarter: "Q1", value: "4", color: "#DC2C36", position: 0 },
                    { id: 1, quarter: "Q2", value: "2", color: "#1D8DFA", position: 1 },
                    { id: 2, quarter: "Q3", value: "0", color: "#10B981", position: 2 },
                    { id: 3, quarter: "Q4", value: "0", color: "#F59E0B", position: 3 }
                ];
                break;
            case 'current-quarter':
                newPositions = [
                    { id: 1, quarter: "Q2", value: "2", color: "#1D8DFA", position: 0 },
                    { id: 2, quarter: "Q3", value: "0", color: "#10B981", position: 1 },
                    { id: 3, quarter: "Q4", value: "0", color: "#F59E0B", position: 2 },
                    { id: 0, quarter: "Q1", value: "4", color: "#DC2C36", position: 3 }
                ];
                break;
            case 'low-scoring':
                newPositions = [
                    { id: 0, quarter: "Q1", value: "4", color: "#DC2C36", position: 0 },
                    { id: 1, quarter: "Q2", value: "2", color: "#1D8DFA", position: 1 },
                    { id: 2, quarter: "Q3", value: "0", color: "#6B7280", position: 2 },
                    { id: 3, quarter: "Q4", value: "0", color: "#6B7280", position: 3 }
                ];
                break;
            default:
                break;
        }

        setQuarterPositions(newPositions);
    };

    return (
        <div style={{ padding: '20px', backgroundColor: '#000', minHeight: '100vh' }}>
            <h2 style={{ color: 'white', textAlign: 'center', marginBottom: '30px' }}>
                Quarter Component Repositioning Test
            </h2>

            {/* Control Panel */}
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '10px',
                marginBottom: '30px',
                flexWrap: 'wrap'
            }}>
                <button
                    onClick={resetPositions}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#007bff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    Reset Positions
                </button>

                <button
                    onClick={() => changeLayout('chronological')}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#28a745',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    Chronological Order
                </button>

                <button
                    onClick={() => changeLayout('score-priority')}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#ffc107',
                        color: 'black',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    Score Priority
                </button>

                <button
                    onClick={() => changeLayout('current-quarter')}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#dc3545',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    Current Quarter Focus
                </button>

                <button
                    onClick={() => changeLayout('low-scoring')}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#6f42c1',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    Low Scoring Game
                </button>
            </div>

            {/* Quarter Components */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '20px',
                maxWidth: '800px',
                margin: '0 auto',
                marginBottom: '30px'
            }}>
                {quarterPositions
                    .sort((a, b) => a.position - b.position)
                    .map((quarter, index) => (
                        <div
                            key={quarter.id}
                            draggable
                            onDragStart={(e) => handleDragStart(e, quarterPositions.findIndex(q => q.id === quarter.id))}
                            onDragEnd={handleDragEnd}
                            onDragOver={(e) => handleDragOver(e, quarterPositions.findIndex(q => q.id === quarter.id))}
                            onDrop={(e) => handleDrop(e, quarterPositions.findIndex(q => q.id === quarter.id))}
                            style={{
                                opacity: draggedIndex === quarterPositions.findIndex(q => q.id === quarter.id) ? 0.5 : 1,
                                transform: draggedIndex === quarterPositions.findIndex(q => q.id === quarter.id) ? 'rotate(5deg)' : 'none',
                                transition: 'all 0.3s ease',
                                border: dragOverIndex === quarterPositions.findIndex(q => q.id === quarter.id) ? '3px dashed #ffffff' : 'none',
                                borderRadius: '10px',
                                padding: '5px'
                            }}
                        >
                            <Quarter
                                value={quarter.value}
                                quarter={quarter.quarter}
                                color={quarter.color}
                                width={quarter.position === 3 ? "200px" : "150px"}
                                height={quarter.position === 3 ? "100px" : "80px"}
                                isLarge={quarter.position === 3}
                                onClick={() => {
                                    const newValue = prompt(`Enter new score for ${quarter.quarter}:`, quarter.value);
                                    if (newValue !== null) {
                                        updateScore(quarterPositions.findIndex(q => q.id === quarter.id), newValue);
                                    }
                                }}
                            />
                        </div>
                    ))}
            </div>

            {/* Instructions */}
            <div style={{
                color: 'white',
                textAlign: 'center',
                maxWidth: '600px',
                margin: '0 auto',
                lineHeight: '1.6'
            }}>
                <h3>Test Instructions for Score [4,2,0,0]:</h3>
                <ul style={{ textAlign: 'left', listStyle: 'none', padding: 0 }}>
                    <li>🖱️ <strong>Drag & Drop:</strong> Click and drag any quarter to reposition it</li>
                    <li>🔄 <strong>Layout Buttons:</strong> Use buttons above to test different arrangements</li>
                    <li>📊 <strong>Update Scores:</strong> Click on any quarter to change its score</li>
                    <li>📱 <strong>Responsive:</strong> Try resizing your browser window</li>
                    <li>🎯 <strong>Q4 Special:</strong> Notice Q4 is always larger when in position 3</li>
                    <li>🏈 <strong>Low Scoring Game:</strong> Q1=4, Q2=2, Q3=0, Q4=0 - typical defensive game</li>
                    <li>🎨 <strong>Color Coding:</strong> Q1 (Red), Q2 (Blue), Q3/Q4 (Gray for 0 scores)</li>
                </ul>
            </div>
        </div>
    );
};

export default QuarterTest;
